import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29c5862c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view" }
const _hoisted_2 = { class: "show-box" }


import {ScForm} from "@/models/ScForm";
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";
import {UrlFieldType} from "@/components/business/crud/interface/FieldType";



import {definedWidgetMeta} from "@/components/business/crud/widgets/widgetManager";

export const meta = definedWidgetMeta({
  size: {edit: 'normal', show: 'normal'},
});

export default /*#__PURE__*/_defineComponent({
  __name: 'UrlForm',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;

const data = ScForm.useFormData();

function ellipsis(text: string, max: number) {
  if (text.length <= max) {
    return text;
  } else {
    return text.slice(0, max - 3) + "..."
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_a_input, {
      value: _unref(data)[_ctx.propName],
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data)[_ctx.propName]) = $event)),
      placeholder: '请填写' + _ctx.info.title
    }, null, 8, ["value", "placeholder"]), [
      [_vShow, _ctx.info.status === 'edit']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(data)[_ctx.propName] || ''), 1)
    ], 512), [
      [_vShow, _ctx.info.status === 'show']
    ])
  ], 64))
}
}

})